import { Component, forwardRef, OnInit } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { UserActionFeatureSystemsComponent } from '../userAction-featureSystem/userAction-featureSystem.component';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { TranslateService } from '@ngx-translate/core';
import { ValidFeatureService } from '../../../../Services/validFeature.service';
import { ValidFeatureSystem } from '../../../../Model/ValidFeatureSystem';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { SystemService } from 'app/Services/system.service';
import { UserActionBaseComponent } from '../userAction-base.component';

@Component({
  selector: 'userAction-deleteFeatureSystems',
  templateUrl: 'userAction-deleteFeatureSystems.component.html',
  providers: [
    { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionDeleteFeatureSystemsComponent) }
  ]
})
export class UserActionDeleteFeatureSystemsComponent extends UserActionFeatureSystemsComponent implements OnInit {
  selectedFeatureSystems: ValidFeatureSystem[];

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    validFeatureService: ValidFeatureService,
    public systemService: SystemService
  ) {
    super(loginService, macroService, catalogService, validFeatureService);
  }

  async ngOnInit() {
    await super.ngOnInit();
  }

  public async canStartMacro() : Promise<boolean>{
    if (!this.selectedFeatureSystems || this.selectedFeatureSystems.length <= 0) {
      this.systemService.notifyInfo(this.translate.instant('mindestens ein FeatureSystem auswählen'));
      return false;
    }

    return true;
  }

  public createParameterStringAsJsonString(): string {
    return JSON.stringify(this.selectedFeatureSystems);
  }
  public parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.selectedFeatureSystems = parsed.selectedFeatureSystems;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
}
